"use client";
import Footer from "@/component/Footer";
import Header from "@/component/Header";
import Sidebar from "@/component/Sidebar";
import { noFooterPath, PUBLIC_ROUTES, Routes } from "@/config/routes";
import { Box, Drawer, Grid, useMediaQuery, useTheme } from "@mui/material";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import ThemeRegistry from "./ThemeRegistry";
import { Suspense } from "react";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import styles from "../styles/global.module.scss";
import Link from "next/link";
import BackToTop from "@/component/BackToTop";
import logo from "../public/images/logo.webp";
export default function ClientLayout({ children }) {
  const theme = useTheme();
  const pathname = usePathname();

  const showSidebar =
    PUBLIC_ROUTES.includes(pathname) || pathname.startsWith(Routes.blogDetails);
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
  const scrollRef = useRef(null);
  useEffect(() => {
    setSidebarOpen(false);
  }, [isMediumScreen]);

  return (
    <ThemeRegistry>
      <div className="flex flex-row h-[100vh] w-full">
        {!showSidebar && !isMediumScreen && (
          <Sidebar
            toggleSidebar={toggleSidebar}
            isMediumScreen={isMediumScreen}
          />
        )}

        {!showSidebar && isMediumScreen && (
          <Drawer open={isSidebarOpen} onClose={toggleSidebar} anchor="left">
            <div className="flex items-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mr-2">
                <Image
                  src={logo}
                  alt="Logo"
                  width={64}
                  height={64}
                  className="rounded-full object-fill"
                />
              </div>
              <span className="text-xl font-semibold text-green-700">
                Macros & Meals
              </span>
            </div>

            <Sidebar
              toggleSidebar={toggleSidebar}
              isMediumScreen={isMediumScreen}
            />
          </Drawer>
        )}
        <div className="flex flex-1 flex-col overflow-auto">
          {!showSidebar && (
            <Suspense fallback={<div style={{ height: 64 }} />}>
              <Header
                isMediumScreen={isMediumScreen}
                toggleSidebar={toggleSidebar}
              />
            </Suspense>
          )}
          <div
            ref={scrollRef}
            className="flex flex-1 flex-col overflow-auto w-full"
          >
            {children}
          </div>
        </div>
        {showSidebar &&
          !noFooterPath.includes(pathname) &&
          !pathname.startsWith("/blog/") && <Footer />}
      </div>
      <ToastContainer autoClose={2000} theme="colored" />
      <BackToTop scrollRef={scrollRef} />
    </ThemeRegistry>
  );
}
